import { FC } from 'react'
import { Box } from '@mui/material'
import theme from 'theme'
import { AssetSource } from 'models'
import { getIntegrationLogo } from 'lib/utils'
import OnyxiaTooltip from 'ui/components/tooltip/OnyxiaTooltip'
import { sourceLabel } from '../utils/assetSources'

interface Props {
  sources: AssetSource[]
  max?: number
}

const SourceCell: FC<Props> = ({ sources, max = 3 }) => {
  if (!sources.length) return null

  const visible = sources.slice(0, max)
  const overflow = sources.length - visible.length

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: `${theme.spacing.half}px` }}>
      {visible.map((source) => (
        <OnyxiaTooltip key={source.instance} title={sourceLabel(source)} placement="top">
          <img
            src={getIntegrationLogo(source.product, 'circle')}
            alt=""
            width={24}
            height={24}
            style={{ minWidth: 24, borderRadius: theme.attributes.borderRadius.small }}
          />
        </OnyxiaTooltip>
      ))}
      {overflow > 0 && (
        <Box
          sx={{
            minWidth: 28,
            height: 24,
            padding: `0 ${theme.spacing.half}px`,
            borderRadius: theme.attributes.borderRadius.small,
            background: theme.colors.chipActiveBg,
            color: theme.colors.devicesSecondaryText,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: theme.typography.fontFamily.primary,
            fontSize: theme.typography.fontSize.medium,
            fontWeight: theme.typography.fontWeight.bold,
            lineHeight: 1
          }}
        >
          +{overflow}
        </Box>
      )}
    </Box>
  )
}

export default SourceCell
